import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import {
  buildYhcAreaCodeWithNameSelections,
  formatYhcAreaCodeWithName,
} from '../constants/area'

const priceColumn = (label: string) =>
  ({
    type: 'NUMBER' as const,
    label,
    replicable: true,
  }) as const

/**
 * 発着都道府県別マスタ
 * - マスタ取込で投入される読み取り専用マスタ（管理画面からの CRUD 不可）
 */
export const yhc_pref_from_to_infos: ModelDef = {
  tableName: 'yhc_pref_from_to_infos',
  tableLabel: '発着都道府県別マスタ',
  primaryKeyColType: 'STRING',
  creatable: false,
  updatable: false,
  deletable: false,
  defaultSort: { key: 'fromPrefCode', order: 'asc' },
  columns: {
    id: {
      type: 'STRING',
      label: 'version-from-to',
      replicable: true,
    },
    version: {
      type: 'STRING',
      label: 'バージョン',
      replicable: true,
      selections: () => $core.$yhcFetchVersions(),
    },
    fromPrefCode: {
      type: 'STRING',
      label: '発エリア',
      replicable: true,
      selections: () => buildYhcAreaCodeWithNameSelections(),
      customLabel: (value) => formatYhcAreaCodeWithName(value),
    },
    toPrefCode: {
      type: 'STRING',
      label: '着エリア',
      replicable: true,
      selections: () => buildYhcAreaCodeWithNameSelections(),
      customLabel: (value) => formatYhcAreaCodeWithName(value),
    },
    sizeRank0NeedDays: {
      type: 'STRING',
      label: '最短所要日数 (サイズランク0)',
      replicable: true,
      inputHelpText: 'ＳＳランク～Ｅランク',
    },
    sizeRank1NeedDays: {
      type: 'STRING',
      label: '最短所要日数 (サイズランク1)',
      replicable: true,
      inputHelpText: 'Ｆランク～Ｇランク（大物）',
    },
    price_ss: priceColumn('80 (SS) 料金'),
    price_s: priceColumn('120 (S) 料金'),
    price_a: priceColumn('160 (A) 料金'),
    price_b: priceColumn('200 (B) 料金'),
    price_c: priceColumn('250 (C) 料金'),
    price_d: priceColumn('300 (D) 料金'),
    price_e: priceColumn('350 (E) 料金'),
    price_f: priceColumn('400 (F) 料金'),
    price_g: priceColumn('450 (G) 料金'),
    price_ss_notax: priceColumn('80 (SS) 料金（税抜）'),
    price_s_notax: priceColumn('120 (S) 料金（税抜）'),
    price_a_notax: priceColumn('160 (A) 料金（税抜）'),
    price_b_notax: priceColumn('200 (B) 料金（税抜）'),
    price_c_notax: priceColumn('250 (C) 料金（税抜）'),
    price_d_notax: priceColumn('300 (D) 料金（税抜）'),
    price_e_notax: priceColumn('350 (E) 料金（税抜）'),
    price_f_notax: priceColumn('400 (F) 料金（税抜）'),
    price_g_notax: priceColumn('450 (G) 料金（税抜）'),
  },
}
